import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "DoubleArrowRight"
});
const _hoisted_1 = {
  class: "icon",
  width: "200px",
  height: "200.00px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M452.992 148.992q8.992-8 20.992-8t20.992 8l331.008 340.992q8.992 8.992 8.992 22.016t-8.992 22.016L494.976 875.008q-8.992 8-20.992 8t-20.992-8.992-8.992-20.992 8.992-20.992l312-320-312-320q-8.992-8.992-8.992-20.992t8.992-22.016z m-256 0q8.992-8 20.992-8t20.992 8l331.008 340.992q8.992 8.992 8.992 22.016t-8.992 22.016L238.976 875.008q-8.992 8-20.992 8t-20.992-8.992-8.992-20.992 8.992-20.992l312-320-312-320q-8.992-8.992-8.992-20.992t8.992-22.016z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var doubleArrowRight = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "E:\\gitlab\\sgui-plus-icon\\packages\\vue\\src\\double-arrow-right.vue"]]);

export { doubleArrowRight as default };
